module.exports = __webpack_public_path__ + "e67687092f58561bc351885af5bcddcd.png";